const appConfig = {
  // Nombre de la empresa, usado en títulos y textos
  companyName: "Delplastic",
  companyDescription: "Tienda online de productos para el hogar y la vida diaria",

  // Controla si se muestra el filtro de precios en la tienda
  // true: para mostrarlo, false: para ocultarlo
  showPriceFilter: false,

  // URL base de la API de productos
  apiUrl: process.env.REACT_APP_API_URL || "https://apidp.nonaminda.com/api",

  // URL base para las imágenes de los productos
  imageBaseUrl: process.env.REACT_APP_IMAGE_BASE_URL || "https://delplastic.com.ar/delplastic/Productos",

  // Duración en minutos de la caché de productos
  productCacheMinutes: 5,

  // Aquí puedes agregar otras configuraciones globales en el futuro
};

export default appConfig;